export default __webpack_public_path__ + "static/media/icon_password_active.b88c7e0a.svg";